import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './route'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import storage from "./utils/storage"
import '@google/model-viewer'

import { install } from "vue3-recaptcha-v2"
import http from "./http/http.js";
import request from "./http/request.js";

const token = storage.get("TOKEN");
if (token) {
    request.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const app = createApp(App)

app.use(router)
app.use(ElementPlus)

app.use(install, {
    sitekey: "6LfpwjcrAAAAAEcGbt8o2sMSKpCI1KXf8PW4TReH",
    cnDomains: false, // Optional, If you use in China, set this value true
  })


app.config.globalProperties.$storage = storage;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app')
